import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";

import {
    SMS_SUPPLIER_MODIFY_METHOD, ACCOUNT_MODIFY_METHOD, PAYMENT_REQUEST_LIST_API, ACCOUNT_GET_DIALER_API,
    TRUNK_LIST_API, TRUNK_LIST_SMS_API, SMS_SUPPLIER_TRUNK_GET_LIST_METHOD,
    SMS_SUPPLIER_RATE_GET_LIST_METHOD, ACCOUNT_PRICE_GET_LIST_API,
    ACCESS_LIST_FILTER_GET_LIST_API, SMS_SUPPLIER_PLAN_GET_LIST_METHOD,
    TRAFFIC_LIMITS_LIST_API, SMS_TRAFFIC_LIMITS_LIST_API,
    POSTBACK_LOGS_GET_LIST_API, ACCOUNT_SERVICE_PLAN_LIST_API,
    ACCOUNT_NOTE_GET_LIST_API, ACCOUNT_CHANGES_LIST_API
} from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { appendIf, servicePick } from "utils";
import { useWindowWidth } from "hooks";
import { API_PAGE_LIST } from "const";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import PageTabs from "components/PageTabs";
import { Header as SectionHeader } from "./Trunks/styled";


export default ({
    service,
    activeTab,
    onSelect,
    serviceCompared,
    accountByService,

    account = {},
    role_list = [],
    isSupplier = false,
    // accountJoinList = [],
    billingServiceList = []
}) => {

    const windowWidth = useWindowWidth();
    const permissions = useSelector(({ auth }) => auth.permissions);
    const permissionLoaded = useSelector(({ auth }) => auth.permissionLoaded);
    const permsReady = permissionLoaded && permissions && permissions.length > 0;

    const {
        // billing,
        account_manager_name,
        currency_name,
        payment_terms_name,
    } = accountByService;

    const ratemodRole = (role_list.includes("Ratemod") || role_list.includes("Ratemod (sms)"));
    const isRatemod = role_list && role_list.length ? ratemodRole : null;

    const supervisorSmsRole = role_list.includes("Supervisor (sms)");
    // const isSupervisorSms = role_list && role_list.length ? supervisorSmsRole : null;

    const createJoinedAccounts = JSON.parse(localStorage.getItem("CREATE_JOINED_ACCOUNTS") || "[]");
    const isCreateJoined = createJoinedAccounts.includes(String(account.id));

    const menuItems = useMemo(() => {
        return [
            ...appendIf(!!account.id, {
                id: "general", eventKey: "general", title: "General"
            }),
            {
                id: "trunks", eventKey: "trunks", title: "Trunks", disabled: !serviceCompared || isCreateJoined, hide: isSupplier,
                checkedMethods: [servicePick(service, TRUNK_LIST_API, TRUNK_LIST_SMS_API)]
            },
            {
                id: "gan_trunks", eventKey: "gan_trunks", title: "GAN Trunks", disabled: !serviceCompared || isCreateJoined, hide: !isSupplier || isRatemod,
                checkedMethods: [SMS_SUPPLIER_TRUNK_GET_LIST_METHOD]
            },
            {
                id: "transit_trunks", eventKey: "transit_trunks", title: "Transit Trunks", disabled: !serviceCompared || isCreateJoined, hide: !isSupplier,
                checkedMethods: [SMS_SUPPLIER_TRUNK_GET_LIST_METHOD]
            },
            {
                id: "rates", eventKey: "rates", title: "Rates", disabled: !serviceCompared || isCreateJoined, hide: isSupplier,
                checkedMethods: [ACCOUNT_PRICE_GET_LIST_API]
            },
            {
                id: "transit_rates", eventKey: "transit_rates", title: "Transit Rates", hide: !isSupplier, disabled: !serviceCompared || isCreateJoined,
                checkedMethods: [SMS_SUPPLIER_RATE_GET_LIST_METHOD]
            },
            {
                id: "access", eventKey: "access", title: "Access List Filters", disabled: !serviceCompared || isCreateJoined, hide: isSupplier,
                checkedMethods: [ACCESS_LIST_FILTER_GET_LIST_API]
            },
            {
                id: "traffic-limits", eventKey: "traffic-limits", title: servicePick(service, "Duration Limits", "Traffic Limits"), disabled: !serviceCompared || isCreateJoined, hide: !service && !isSupplier,
                checkedMethods: [servicePick(service, TRAFFIC_LIMITS_LIST_API, SMS_TRAFFIC_LIMITS_LIST_API)]
            },
            {
                id: "postback-logs", eventKey: "postback-logs", title: "Postback Logs", disabled: !serviceCompared || isCreateJoined, hide: service || isSupplier,
                checkedMethods: [POSTBACK_LOGS_GET_LIST_API]
            },
            { id: "api", eventKey: "api", title: "API Keys", disabled: !serviceCompared || isCreateJoined, hide: isSupplier, checkedMethods: [API_PAGE_LIST] },
            {
                id: "self-allocation", eventKey: "self-allocation", title: "Trunk settings", disabled: !serviceCompared || isCreateJoined, hide: isSupplier,
                checkedMethods: [ACCOUNT_SERVICE_PLAN_LIST_API]
            },
            { id: "payment-management", eventKey: "payment-management", title: "Payment management", checkedMethods: [PAYMENT_REQUEST_LIST_API], disabled: isCreateJoined },
            { id: "notes", eventKey: "notes", title: "Notes", checkedMethods: [ACCOUNT_NOTE_GET_LIST_API], disabled: isCreateJoined },
            { id: "changes", eventKey: "changes", title: "Changes", checkedMethods: [ACCOUNT_CHANGES_LIST_API], disabled: isCreateJoined }
        ];
    }, [account.id, serviceCompared, isSupplier, isRatemod, isCreateJoined, service]);

    const filterMenuItems = (menuItems, currentPermissions) => {
        return menuItems.filter((item) => {
            const checkedMethods = [];

            if (item.checkedMethods) {
                for (const method of item.checkedMethods) {
                    checkedMethods.push(checkPermissionsFor(method, currentPermissions));
                }
            }

            if (!!item && !item.hide && checkedMethods.every((check) => check === true)) {
                return true;
            }
        });
    };

    const visibleMenuItems = useMemo(() => {
        if (!permsReady) {
            return menuItems.filter((item) => !item.hide);
        }

        return filterMenuItems(menuItems, permissions);
    }, [menuItems, permissions, permsReady]);

    const dropdownTitle = (visibleMenuItems.find(item => item.eventKey === activeTab) || {}).title;
    const isMobile = windowWidth < 1200;

    useEffect(() => {
        if (activeTab === "general") return;
        if (!account?.service) return;
        if (!permsReady) return;
        if (visibleMenuItems.length === 0) return;

        const items = visibleMenuItems;
        const activeItem = items.find(item => item.eventKey === activeTab);

        if (!activeItem || activeItem.disabled) {
            onSelect("general");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, visibleMenuItems, permsReady, serviceCompared, service, isSupplier, account.id]);

    return (
        <>
            <Header>
                <>
                    <div><Name>Account:</Name><Value>{account?.name}</Value></div>
                    <div><Name>Manager:</Name><Value>{account_manager_name}</Value></div>
                    <div><Name>Currency:</Name><Value>{currency_name}</Value></div>
                    <div><Name>Payment terms:</Name><Value>{payment_terms_name}</Value></div>
                </>

                <CurrencyContainer>
                    {billingServiceList && billingServiceList.length
                        ? billingServiceList.map(billingService => {
                            const currentCurrencyName = billingService?.currency_name;
                            return <CurrencyService>
                                <ServiceCell service={billingService?.service}>{billingService?.service}</ServiceCell>
                                <CurrencyCell minWidth={210}>
                                    <Name>Pending amount:</Name>
                                    <Value>{billingService?.pending_amount} {currentCurrencyName}</Value>
                                </CurrencyCell>
                                {!isSupplier ? <CurrencyCell minWidth={220}>
                                    <Name>Ready for payment:</Name>
                                    <Value>{billingService?.ready_for_payment} {currentCurrencyName}</Value>
                                </CurrencyCell> : <></>}
                                <CurrencyCell minWidth={210}>
                                    <Name>Invoiced balance:</Name>
                                    <Value>{billingService?.BALANCE_INV2} {currentCurrencyName}</Value>
                                </CurrencyCell>
                            </CurrencyService>
                        }) : <></>}
                </CurrencyContainer>
            </Header>

            {!isMobile
                ? <PageTabs
                    {...{
                        activeTab,
                        onSelect,
                        menuItems: visibleMenuItems
                    }}
                />
                : <>
                    <FlexGrid
                        noWrap
                        align={"middle"}
                        justify={"space-between"}
                    >
                        <FlexGridItem>
                            <SectionHeader>{dropdownTitle}</SectionHeader>
                        </FlexGridItem>
                        <FlexGridItem>
                            <PageTabs
                                isMobile={true}
                                {...{
                                    activeTab,
                                    onSelect,
                                    menuItems: visibleMenuItems
                                }}
                            />
                        </FlexGridItem>
                    </FlexGrid>
                </>
            }
        </>
    )
}

const CurrencyContainer = styled.div`
    && {
        /* margin-left: auto; */
        display: flex;
        flex-direction: column;
    }

    && div {
        display: inline-block;
        text-align: start;
    }

    /* @media (min-width: 768px) {

    } */
`;

const CurrencyService = styled.span`
    && {
        text-align: end;
    }

    @media (max-width: 767px) {
        && {
            text-align: start;
        }
    }
`;

const ServiceCell = styled.div`
    && {
        color: var(--color-main);
        text-align: start;
        margin-right: 10px;
        min-width: 40px;
        font-weight: 700;
    }

    @media (max-width: 767px) {
        && {
            text-align: start;
            display: block;
            width: 100%;
            font-size: 17px;
            margin-bottom: 5px;
        }
    }
`;

const CurrencyCell = styled.div`
    && {
        ${props => props.minWidth && css`
            min-width: ${props.minWidth}px;
        `}
    }

    @media (max-width: 767px) {
        && {
            margin-bottom: 10px;
        }
    }
`

const Name = styled.span`
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: var(--color-main);
    margin-right: 3px;
`;

const Value = styled.span`
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #363434;
    margin-right: 15px;
`;

const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    
    & > div {
        padding-bottom: 10px;
    }
`;